import type { BoxProps } from "@mui/material";
import type React from "react";
import { createContext, useContext, useMemo } from "react";

export interface IGroupedVirtualizedContext {
  slotProps?: {
    list?: Partial<BoxProps>;
    listItem?: Partial<BoxProps>;
    group?: Partial<BoxProps>;
  };
}

interface IGroupedVirtualizedProviderProps extends IGroupedVirtualizedContext {
  children: React.ReactNode;
}

const context = createContext<IGroupedVirtualizedContext>({});

export const useGroupedVirtualizedContext = () => useContext(context);

export const GroupedVirtualizedProvider = ({ children, ...props }: IGroupedVirtualizedProviderProps) => {
  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  const value = useMemo(() => ({ ...props }), [props.slotProps]);

  return <context.Provider value={value}>{children}</context.Provider>;
};
